import { Component, OnInit, Input } from '@angular/core';
import { BaseStepComponent } from '../../base';

@Component({
  selector: 'pontuacao-homologacao',
  templateUrl: './pontuacao-homologacao.component.html'
})
export class PontuacaoHomologacaoComponent extends BaseStepComponent {

  @Input() listaPntCRC: any[];
  @Input() listaPntCFC: any[];
  @Input() etapa: number;
  @Input() controladorGerenciamento:boolean=true;
  @Input() ehLista:boolean=true;
  init() {

  }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/pontuacao-homologacao/pontuacao-homologacao.component.ts